import { WorkItemStatus } from './WorkItemStatus';

export const hiddenWorkItemStatuses = [
  // ...
  WorkItemStatus.ARCHIVED,
];
